/**
 * Protège React contre les erreurs NotFoundError sur removeChild / insertBefore.
 *
 * Cause fréquente : traduction auto du navigateur (Chrome/Edge), Grammarly, etc.
 * qui réécrivent le DOM pendant que React réconcilie.
 *
 * Voir skill `chrome-autotranslate-removechild`.
 */
export function patchDomNodeMutations(): void {
  if (typeof Node === "undefined" || typeof window === "undefined") {
    return;
  }

  const win = window as Window & { __flashPayDomPatchApplied?: boolean };
  if (win.__flashPayDomPatchApplied) {
    return;
  }
  win.__flashPayDomPatchApplied = true;

  const originalRemoveChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function <T extends Node>(child: T): T {
    if (child.parentNode !== this) {
      if (child.parentNode) {
        return originalRemoveChild.call(child.parentNode, child) as T;
      }
      return child;
    }
    return originalRemoveChild.call(this, child) as T;
  };

  const originalInsertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function <T extends Node>(
    newNode: T,
    referenceNode: Node | null
  ): T {
    if (referenceNode && referenceNode.parentNode !== this) {
      return originalInsertBefore.call(this, newNode, null) as T;
    }
    return originalInsertBefore.call(this, newNode, referenceNode) as T;
  };
}
